<template>
    <article class="m-team__member">
        <div class="m-team__member__imagewrapper relative aspect-[11/10]">
            <div v-if="croppedDefaultImage">
                <img
                    class="absolute w-full h-full object-cover"
                    :src="croppedDefaultImage"
                    loading="lazy"
                    :alt="`${vorname} ${nachname}`"
                />
            </div>
            <div v-else>
                <div class="absolute w-full h-full object-cover bg-custom-grey-1" />
            </div>
            <a class="p-4 bg-custom-red-1 rounded absolute left-0 bottom-0" :href="vcardurl">
                <svg class="w-[38px] h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.721 30.138">
                    <g id="Gruppe_168" data-name="Gruppe 168" transform="translate(0 0)">
                        <g id="Gruppe_169" data-name="Gruppe 169" transform="translate(0 0)">
                            <path id="Pfad_173" data-name="Pfad 173" d="M128.719,109.332a5.758,5.758,0,0,0-5.779-5.731H95.777A5.769,5.769,0,0,0,90,109.379v18.579a5.769,5.769,0,0,0,5.779,5.779H122.94a5.769,5.769,0,0,0,5.779-5.779Zm-5.779,22.114H95.778a3.506,3.506,0,0,1-3.487-3.487V109.331a3.506,3.506,0,0,1,3.487-3.487H122.94a3.506,3.506,0,0,1,3.487,3.487v18.627A3.506,3.506,0,0,1,122.94,131.445Z" transform="translate(-89.998 -103.6)" fill="#fff"/>
                            <path id="Pfad_174" data-name="Pfad 174" d="M351.045,213.8h-9.1a1.146,1.146,0,0,0,0,2.293H351a1.162,1.162,0,0,0,1.146-1.146A1.092,1.092,0,0,0,351.045,213.8Z" transform="translate(-319.406 -204.403)" fill="#fff"/>
                            <path id="Pfad_175" data-name="Pfad 175" d="M351.045,266.56h-9.1a1.146,1.146,0,1,0,0,2.293H351a1.162,1.162,0,0,0,1.146-1.146A1.122,1.122,0,0,0,351.045,266.56Z" transform="translate(-319.406 -252.661)" fill="#fff"/>
                            <path id="Pfad_176" data-name="Pfad 176" d="M351.045,319.318h-9.1a1.146,1.146,0,0,0,0,2.293H351a1.162,1.162,0,0,0,1.146-1.146A1.122,1.122,0,0,0,351.045,319.318Z" transform="translate(-319.406 -300.919)" fill="#fff"/>
                            <path id="Pfad_177" data-name="Pfad 177" d="M162.58,182.7h0a4.621,4.621,0,0,0,1.385-3.3,4.681,4.681,0,1,0-9.361,0,4.539,4.539,0,0,0,1.385,3.3,7.794,7.794,0,0,0-3.63,6.687c0,.764.335,2.149,2.531,3.057a12.323,12.323,0,0,0,4.442.764c3.487,0,6.973-1.194,6.973-3.821A8.1,8.1,0,0,0,162.58,182.7Zm-3.3-5.683a2.388,2.388,0,1,1,0,4.776A2.4,2.4,0,0,1,156.9,179.4,2.365,2.365,0,0,1,159.284,177.013Zm0,13.9c-2.866,0-4.633-.908-4.633-1.529,0-2.913,2.1-5.3,4.633-5.3,2.579,0,4.633,2.388,4.633,5.3C163.917,190,162.15,190.912,159.284,190.912Z" transform="translate(-147.04 -168.654)" fill="#fff"/>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
        <p class="m-team__member__header mt-4">
            <span class="leading-none text-custom-h3-mobile xl:text-custom-h3 font-semibold" v-if="vorname && nachname">{{vorname}} {{nachname}}<br /></span>
            <span class="leading-none text-custom-h4-mobile xl:text-custom-h4 font-semibold mt-2" v-if="funktion">{{funktion}}</span>
        </p>
        <p class="m-team__member__contact mt-4">
            <span v-if="standorte && standorte.length">{{standorte[0].name}}<br /></span>
            <span v-if="telefon"><a class="underline" :href="`tel:${telefon}`">{{telefon}}</a><br /></span>
            <span v-if="mobiltelefon"><a class="underline" :href="`tel:${mobiltelefon}`">{{mobiltelefon}}</a><br /></span>
            <span class="underline" v-if="email"><a @click.prevent="mailto()" href="#">{{emailvisualized}}</a><br /></span>
        </p>
    </article>
</template>

<script>
export default {
    name: `Member`,
    props: {
        vorname: String,
        nachname: String,
        croppedDefaultImage: String,
        foto: Object,
        funktion: String,
        standorte: Array,
        telefon: String,
        mobiltelefon: String,
        email: String,
        urlsegment: String,
    },
    methods: {
        mailto: function () {
            window.location.href = "mailto:" + this.email;
        }
    },
    computed: {
        emailvisualized() {
            return this.email ? this.email.replace("@", "(at)") : '';
        },
        vcardurl() {
            return "/team/vcard/" + this.urlsegment + ".vcf";
        }
    }
}
</script>

<style scoped>
.reverse {
    unicode-bidi: bidi-override;
    direction: rtl;
    text-decoration: underline;
}
.cryptedmail:after {
    content: attr(data-name) "@" attr(data-domain) "." attr(data-tld);
    text-decoration: underline;
}
</style>
